import React, { useState, useEffect } from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import c from 'classnames';
import config from 'react-global-configuration';
import { SCREEN_NORMAL } from '../../../config/constants';

import useWindowDimensions from '../../../helpers/useWindowDimensions';
import NavigationMainMenuSubComponent from './NavigationMainMenuSubComponent';

import './style.scss';

const NavigationMainMenuDesktop = ({
  path,
  toggleNavigationItem,
  menuItemsToggled,
  items,
}) => {
  const { width } = useWindowDimensions();
  const [interacted, setInteracted] = useState(false);
  const [active, setActive] = useState(null);

  const classNames = c('NavigationMainMenuDesktop', {
    'NavigationMainMenuDesktop--interacted': interacted,
  });

  useEffect(() => {
    const onBodyClick = () => {
      setActive(null);
    };

    document.body.addEventListener('click', onBodyClick);

    return () => {
      document.body.removeEventListener('click', onBodyClick);
    };
  }, [setActive]);

  return (
    <div className={classNames} onClick={() => setInteracted(true)}>
      <div className="NavigationMainMenuDesktop__items">
        {items.map((item, index) => {
          const href = item.getIn(['link', 'url'], '');
          const title = item.getIn(['link', 'title'], 'Untitled');
          const entityId = item.getIn(
            ['link', 'meta_data', 'entity_id'],
            'Untitled',
          );
          const hasSubtree = item.get('subtree', '').size > 0;

          return (
            <li
              key={`menu--main--menu-item-${title}:${href}`}
              className={c('menu--main--menu-item', {
                'menu--menu-item--active': item.getIn(['link', 'url']) === path,
                'menu--main--menu--hovered': active === index,
                'menu--main--menu--inactive': active !== index,
              })}
            >
              {hasSubtree ? (
                <div
                  className="NavigationMainMenuDesktop__itemWrapper"
                  onClick={(event) => {
                    event.stopPropagation();
                    toggleNavigationItem(entityId);

                    if (active === index) {
                      setActive(null);
                    } else {
                      setActive(index);
                    }
                  }}
                >
                  <a
                    className="NavigationMainMenuDesktop__title"
                  >
                    {title}
                  </a>
                  <div
                    className={c(
                      'NavigationMainMenuDesktop__items__arrow icon-after icon-arrow-down icon-variant-4',
                      {
                        'icon-arrow-up': menuItemsToggled[entityId] === true,
                      },
                    )}
                  />
                </div>
              ) : (
                <div className="NavigationMainMenuDesktop__itemWrapper">
                  <CoreLink
                    to={href}
                    className="NavigationMainMenuDesktop__title"
                  >
                    {title}
                  </CoreLink>
                </div>
              )}
              {(menuItemsToggled[entityId] === true || width >= SCREEN_NORMAL) && (
                <NavigationMainMenuSubComponent
                  setActive={setActive}
                  item={item}
                  domainKp={config.get('CURRENT_DOMAIN') === 'kp'}
                />
              )}
            </li>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationMainMenuDesktop;
